import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Bearer token fallback (works even when browser blocks cookies)
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem("cognihub_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("cognihub_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

// Restore token on load
const saved = typeof localStorage !== "undefined" ? localStorage.getItem("cognihub_token") : null;
if (saved) {
  api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
}

// Chamado quando o refresh do token falha (sessao realmente expirada). Registado pelo AuthProvider.
let onSessionExpired = () => {};
export function setSessionExpiredHandler(fn) {
  onSessionExpired = fn;
}

// Pedidos de autenticacao que nunca devem passar pelo interceptor de refresh (evita loops).
const AUTH_SKIP_PATHS = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/mfa"];
let refreshPromise = null;

// O access token expira 1x/hora. Em vez de deixar o utilizador com a app
// "presa" sem feedback, tentamos renovar silenciosamente via refresh token
// (cookie httpOnly, valido 7 dias) e repetir o pedido original. Se o refresh
// tambem falhar (sessao expirada de verdade), termina a sessao e avisa o utilizador.
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (!response || response.status !== 401 || !config || config._retried) {
      return Promise.reject(error);
    }
    const url = config.url || "";
    if (AUTH_SKIP_PATHS.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    config._retried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      }
      const { data } = await refreshPromise;
      if (data?.access_token) setAuthToken(data.access_token);
      return api(config);
    } catch (refreshErr) {
      setAuthToken(null);
      onSessionExpired();
      return Promise.reject(error);
    }
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
